<template>
  <div>
    <div class="font-weight-bold">
      {{ isScheduled ? "Title: " + meeting.title : "Room: " + meeting.room }}
    </div>

    <div>{{ isScheduled ? "Time: " + timeRange : "Type: Quick Link" }}</div>

    <div v-if="meeting.description" class="my-2">
      Description: {{ meeting.description }}
    </div>

    <div class="my-2 d-flex">
      <div class="small text-break">{{ meetingLink }}</div>
      <b-btn
        class="ml-4 mb-auto"
        size="sm"
        variant="white"
        @click="$copy(meetingLink)"
      >
        <i class="icon-docs" />
      </b-btn>
    </div>

    <div class="mx-auto d-flex w-50">
      <span class="font-weight-bold">Meeting ID</span>
      <span class="ml-auto">{{ meeting.id }}</span>
    </div>

    <div v-if="meeting.password" class="mx-auto d-flex w-50">
      <span class="font-weight-bold">Password</span>
      <span class="ml-auto">{{ meeting.password }}</span>
    </div>

    <template v-if="isScheduled">
      <hr />
      <div class="mb-2 font-weight-bold text-center">
        Add this meeting to your calendar?
      </div>
      <b-form-row>
        <b-col
          v-for="cal in calendarLinks"
          :key="cal.id"
          cols="3"
          class="d-flex"
        >
          <b-btn
            :href="cal.link"
            target="_blank"
            variant="primary"
            class="d-flex align-items-center justify-content-center"
            block
          >
            {{ cal.text }}
          </b-btn>
        </b-col>
      </b-form-row>
    </template>
  </div>
</template>

<script>
import * as calendar from "calendar-link";
import moment from "moment";

const calendars = [
  { text: "Google Calendar", id: "google" },
  { text: "Outlook", id: "outlook" },
  { text: "Office365", id: "office365" },
  { text: "Download ICS", id: "ics" }
];

export default {
  props: {
    meeting: Object
  },

  computed: {
    calendarLinks() {
      return calendars.map(cal => ({
        ...cal,
        link: calendar[cal.id]({
          ...this.meeting,
          description: this.meetingSummary
        })
      }));
    },

    isScheduled() {
      return !!this.meeting.start;
    },

    meetingLink() {
      const { id, room, password } = this.meeting;
      const payload = { type: "join", id, room, password };
      if (this.isScheduled) Object.assign(payload, this.meeting);
      if (!payload.password) delete payload.password;
      return "https://open.nanome.ai/#/" + btoa(JSON.stringify([payload]));
    },

    meetingSummary() {
      return [
        `${this.meeting.title}\n`,
        `${this.timeRange}\n`,
        `To join the Nanome meeting, click this link:`,
        `<a href="${this.meetingLink}">${this.meetingLink.substr(8)}</a>\n`,
        `Or enter the Meeting ID and Password on the Meetings tab in the Nanome Lobby`,
        `Meeting ID: ${this.meeting.id}`,
        this.meeting.password ? `Password: ${this.meeting.password}\n` : "",
        `${this.meeting.description}\n`,
        `To attend the meeting, download Nanome at <a href="https://nanome.ai/setup">nanome.ai/setup</a>`
      ].join("\n");
    },

    timeRange() {
      const { start, end } = this.meeting;
      const startText = moment(start).format("dddd, MMM DD h:mm a");
      const endText = moment(end).format("h:mm a");
      return `${startText} - ${endText}`;
    }
  }
};
</script>
